import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES } from './constants.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-offering-catalogue-features", jiraSpaEntry: "async-resource-offering-catalogue-features" */ './controllers/get-data'
	);

export const fetchFeatureDataResource: RouteResource<string | null> = createResource<string | null>(
	{
		type: RESOURCE_TYPE_OFFERING_CATALOGUE_FEATURES,
		getKey: () => 'state',
		getDataLoader,
		maxAge: 30 * 60 * 1000,
	},
);

export const getOfferingCatalogueFeaturesResource = (): never[] => [];
